export default __webpack_public_path__ + "static/media/pagosfooter.30465f68.png";